<template>
  <a-result v-if="request.intercept.check||request.data.isWrite"
            class="box_result" status="info"
            title="正在登录" sub-title="用户信息校验中..." />
  <section v-else
           id="replenish" class="box_sso replenish">
    <SSOBackground />
    <div class="container">
      <div class="box_table">
        <div class="cell">
          <a-row>
            <!--<a-col :xs="24" :lg="!$Store.User().isHideMsg?12:24">-->
            <a-col :xs="24">
              <a-form ref="form"
                      :model="form.data" :rules="form.rule">
                <!--<i class="logo" />-->
                <a-typography-title :level="1">
                  完善信息
                </a-typography-title>
                <!--<a-typography-title :level="2">-->
                <!--    现在注册应用市场，<br v-if="$Store.Public().isGridMatch('<',$Enum.GridEnum.LG)" />即刻免费体验30分钟AI应用-->
                <!--</a-typography-title>-->
                <a-form-item name="name" has-feedback>
                  <a-input v-model:value="form.data.name" placeholder="用户名"
                           :maxlength="$Check.Constraint.Max"
                           :show-count="form.data.name.length>0" allow-clear>
                    <template #prefix>
                      <UserOutlined class="input_icon" />
                    </template>
                  </a-input>
                </a-form-item>
                <!--<a-row justify="center">-->
                <!--    <a-col :xs="24" :sm="20">-->
                <!--        <a-divider dashed />-->
                <!--        <a-typography-paragraph>-->
                <!--            为了更好的为您服务，请补充填写相关信息-->
                <!--        </a-typography-paragraph>-->
                <!--    </a-col>-->
                <!--</a-row>-->
                <a-form-item name="real_name" has-feedback>
                  <a-input v-model:value="form.data.real_name" placeholder="姓名"
                           :maxlength="$Check.Constraint.RealNameMax"
                           :show-count="form.data.real_name.length>0" allow-clear>
                    <template #prefix>
                      <IdcardOutlined class="input_icon" />
                    </template>
                  </a-input>
                </a-form-item>
                <a-form-item name="ent_name" has-feedback>
                  <a-input v-model:value="form.data.ent_name" placeholder="企业/学校"
                           :maxlength="$Check.Constraint.MaxX"
                           :show-count="form.data.ent_name.length>0" allow-clear>
                    <template #prefix>
                      <TeamOutlined class="input_icon" />
                    </template>
                  </a-input>
                </a-form-item>
                <a-form-item name="position" has-feedback>
                  <a-input v-model:value="form.data.position" placeholder="职位"
                           :maxlength="$Check.Constraint.MaxX"
                           :show-count="form.data.position.length>0" allow-clear>
                    <template #prefix>
                      <SolutionOutlined class="input_icon" />
                    </template>
                  </a-input>
                </a-form-item>
                <a-form-item name="email" has-feedback>
                  <a-auto-complete v-model:value="form.data.email" v-model:options="expand.mail"
                                   @search="mail=>expand.mail=$FN.FormatMail(mail)"
                                   @select="mail=>form.data.email=mail">
                    <a-input placeholder="邮箱"
                             :maxlength="$Check.Constraint.Max2X"
                             :show-count="form.data.email.length>0" allow-clear>
                      <template #prefix>
                        <MailOutlined class="input_icon" />
                      </template>
                    </a-input>
                    <template #option="{ value }">
                      {{ value.split('@')[0] }}
                      <span class="text_bold">
                        @ {{ value.split('@')[1] }}
                      </span>
                    </template>
                  </a-auto-complete>
                </a-form-item>
                <a-row>
                  <a-col :span="24">
                    <a-button type="primary"
                              :loading="request.intercept.submit"
                              @click="submit" block>
                      提交
                    </a-button>
                  </a-col>
                </a-row>
              </a-form>
            </a-col>
            <!--<a-col v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.LG)&&!$Store.User().isHideMsg"-->
            <!--       :xs="24" :lg="12">-->
            <!--  <SSOIntroduce />-->
            <!--</a-col>-->
          </a-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import {
  UserOutlined,
  IdcardOutlined,
  TeamOutlined,
  SolutionOutlined,
  MailOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import {
  AuthTypeEnum,
  RequestCheckUserInfo, ResponseCheckUserInfo, AxiosCheckUserInfo,
  RequestPostUserInfo, ResponsePostUserInfo, AxiosPostUserInfo
} from '@server/apiSSO';
import SSOBackground from '@template/sso/_component/background.vue';
import SSOIntroduce from '@template/sso/_component/introduce.vue';

export default {
  name: 'replenish',
  components: {
    UserOutlined,
    IdcardOutlined,
    TeamOutlined,
    SolutionOutlined,
    MailOutlined,
    SSOBackground,
    SSOIntroduce
  },
  data(): DataInterface {
    return {
      request: {
        intercept: {
          submit: false,
          check: false
        },
        data: {
          isWrite: false
        }
      },
      form: {
        rule: {
          name: $Check.Rule.UserName(),
          email: $Check.Rule.Mail(),
          real_name: $Check.Rule.RealName(),
          ent_name: ((name: string) => [
            $Check.Rule.Required(name),
            $Check.Rule.Length(name, $Check.Constraint.Min, $Check.Constraint.MaxX)
          ])('企业/学校'),
          position: ((name: string) => [
            $Check.Rule.Required(name),
            $Check.Rule.Length(name, $Check.Constraint.Min, $Check.Constraint.Max)
          ])('职位')
        },
        data: {
          target_type: AuthTypeEnum.Phone,
          name: '',
          phone: undefined,
          email: '',
          code: undefined,
          pwd: undefined,
          real_name: '',
          ent_name: '',
          position: '',
          app_id: undefined
        }
      },
      expand: {
        mail: []
      }
    };
  },
  mounted(): void {
    this.checkUserInfo();
  },
  methods: {
    /**
     * 提交
     */
    async submit(): Promise<any> {
      await this.$refs.form.validateFields()
        .then(async () => {
          if (this.request.intercept.submit) return;
          this.request.intercept.submit = true;
          
          await AxiosPostUserInfo({
            name: this.form.data.name,
            email: this.form.data.email,
            real_name: this.form.data.real_name,
            ent_name: this.form.data.ent_name,
            position: this.form.data.position
          } as RequestPostUserInfo)
            .then(async (response: any) => {
              const data: ResponsePostUserInfo = response.data;
              
              if (data.code !== $Enum.CodeEnum.Normal) return;
              
              $Store.User().updateInfo({
                token: data.data.token,
                userID: data.data.user_id,
                username: data.data.name
              });
              !$Store.User().operate && $Store.User().$patch({
                operate: $Enum.OperateEnum.Register
              });
              
              $FN.Message('success', {
                content: $Enum.TextEnum.SuccessRegister
              });
              
              this.$router.push($Enum.RouterEnum.Back);
              
              $RQ.PushWebHookFeiShu(
                $Store.User().username,
                `${ $Enum.TextEnum.OperateReplenish }：${ $Store.User().source || location.href }`
              );
            })
            .finally(() => {
              this.request.intercept.submit = false;
            });
        })
        .catch(() => {
          $FN.Message('warning', {
            content: $Enum.TextEnum.ErrorCheckFail
          });
        });
    },
    
    /**
     * 检查用户信息
     */
    async checkUserInfo(): Promise<any> {
      this.request.data.isWrite = true;
      this.request.data.isWrite && this.$router.push($Enum.RouterEnum.Back);
      
      // if (this.request.intercept.check) return;
      // this.request.intercept.check = true;
      //
      // await AxiosCheckUserInfo({} as RequestCheckUserInfo)
      //   .then(async (response: any) => {
      //     const data: ResponseCheckUserInfo = response.data;
      //
      //     if (data.code !== $Enum.CodeEnum.Normal) return;
      //
      //     this.request.data.isWrite = data.data.is_writen;
      //     this.request.data.isWrite && this.$router.push($Enum.RouterEnum.Back);
      //   })
      //   .finally(() => {
      //     this.request.intercept.check = false;
      //   });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
@import '@resource/css/sso.less';

@image: '@{src_image}sso/';

.replenish {
  .ant-form {
    background: fade(@color_white, 95);
    .shadow(0 10px 30px fade(@color_black, 10));
    
    h1.ant-typography {
      margin: 0 0 20px;
    }
  }
}
</style>